import { render, staticRenderFns } from "./updateUserStatus.vue?vue&type=template&id=71ad3008&scoped=true"
import script from "./updateUserStatus.vue?vue&type=script&lang=js"
export * from "./updateUserStatus.vue?vue&type=script&lang=js"
import style0 from "./updateUserStatus.vue?vue&type=style&index=0&id=71ad3008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad3008",
  null
  
)

export default component.exports